import React from 'react';

import { Box } from '@qga/roo-ui/components';
import ErrorBoundary from 'components/errors/ErrorBoundary';

interface LayoutProps {
  children: React.ReactNode;
}

const MinimalLayout = ({ children }: LayoutProps) => {
  return (
    <>
      <Box flex="1 0 auto" width="100%" bg="greys.porcelain">
        <ErrorBoundary>{children}</ErrorBoundary>
      </Box>
    </>
  );
};

export default MinimalLayout;
